import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import Components from './components'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './modules/icons'

Vue.config.productionTip = false

Vue.component('FontAwesomeIcon', FontAwesomeIcon)

Vue.use(Components)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
